import React from 'react';
import { Avatar, Flex, Typography } from 'antd';
// import './ArrowButton.css';
import { getIcon, ICONS } from '../../icons';
import { COLOURS } from '../../colours';
import useMobileCheck from '../../mobile';

const { Text, Paragraph } = Typography;

const Quote = ({
  quote,
  name,
  title,
  photoURL,
  stars,
  style
}) => {
  const { isMobile } = useMobileCheck();
  return (
    <Flex 
      style={{ 
        width: '100%', 
        padding: '32px',
        border: '1px solid #E8E8E8',
        borderRadius: '20px',
        ...style
      }}
      vertical gap={8}>
      <Paragraph>{quote}</Paragraph>
      <Flex
        style={{ 
          width: '100%',
          gridTemplateColumns: isMobile ? "auto 100px" : "32px auto 100px"
        }}
        gap={16}
        >
        <Flex
          style={{ 
            flexGrow: 3
          }}
          vertical>
          <Text>{name}</Text>
          <Text>{title}</Text>
        </Flex>
        <Flex>
          {Array.from({ length: 5 }, (_, index) => {
            return getIcon(ICONS.STAR, false, {
              secondary: index < stars ? 'orange' : COLOURS.TERTIARY
            } )
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Quote;
